// src/App.js
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./auth/ProtectedRoute";
import { ROUTE_ACCESS } from "./auth/permissions";
import { ThemeProvider } from "./context/themeContext";
import "./theme.css";

import ChurchList from "./pages/churches/churchList";
import EnabledRolesPage from "./pages/enabledRoles/enabledRoles";
import Login from "./pages/login/loginPage";
import HomePage from "./pages/home/homePage";

import UserList from "./pages/userManagement/userList/userList";

import MemberList from "./pages/memberManagement/memberList/memberList";
import MemberDetails from "./pages/memberManagement/memberDetails/memberDetails";

import LeaderList from "./pages/leaderManagement/leaderList/leaderList";
import LeaderDetails from "./pages/leaderManagement/leaderDetails/leaderDetails";

import EventList from "./pages/calendar/eventList/eventList";
import EventDetails from "./pages/calendar/eventDetails/eventDetails";

import RequestList from "./pages/eventRequests/requestList/requestList";
import RequestDetails from "./pages/eventRequests/requestDetails/requestDetails";

import AnnouncementList from "./pages/announcements/announcementList/announcementList";
import AnnouncementDetails from "./pages/announcements/announcementDetails/announcementDetails";

import PrayerManagement from "./pages/prayers/prayerList/prayerList";
import PrayerDetails from "./pages/prayers/prayerDetails/prayerDetails";

import TestimonyManagement from "./pages/testimonies/testimonyList/testimonyList";
import TestimonyDetails from "./pages/testimonies/testimonyDetails/testimonyDetails";

import AudioManagement from "./pages/contentManagement/audios/audioList";
import BibleVersionManagement from "./pages/contentManagement/bibleVersions/bibleVersionList";
import DevotionManagement from "./pages/contentManagement/devotions/devotionList";
import DocumentManagement from "./pages/contentManagement/documents/documentList";
import QuoteManagement from "./pages/contentManagement/quotes/quoteList";
import PodcastManagement from "./pages/contentManagement/podcasts/podcastList";
import StreamingManagement from "./pages/contentManagement/streaming/streamingList";
import VerseManagement from "./pages/contentManagement/verses/versesList";

import FormList from "./pages/volunteering/formList";
import CreateForm from "./pages/volunteering/createForm";
import EditForm from "./pages/volunteering/editForm";
import FormsSubmissions from "./pages/volunteering/formSubmissions";

import DonationList from "./pages/donations/donationList";

import ReportsAndAnalytics from "./pages/reports/reportList";

import SettingsAndPreferences from "./pages/settings/settingsPage";

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          {/* Public route */}
          <Route path="/" element={<Login />} />

          {/* Protected routes */}
          <Route
            path="/churches"
            element={
              <ProtectedRoute>
                <ChurchList />
              </ProtectedRoute>
            }
          />

          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/enabledRoles"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/enabledRoles"]}>
                <EnabledRolesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/userList"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/userManagement"]}>
                <UserList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/memberDetails/:membershipId"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/memberManagement"]}>
                <MemberDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/memberList"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/memberManagement"]}>
                <MemberList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leaderList"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/leaderManagement"]}>
                <LeaderList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leaderDetails/:userId"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/leaderManagement"]}>
                <LeaderDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/eventList"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/calendar"]}>
                <EventList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/eventDetails"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/calendar"]}>
                <EventDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/requestList"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/eventRequests"]}>
                <RequestList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/requestDetails"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/eventRequests"]}>
                <RequestDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/announcementList"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/announcements"]}>
                <AnnouncementList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/announcementDetails"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/announcements"]}>
                <AnnouncementDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="/prayerList"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/prayers"]}>
                <PrayerManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/prayerDetails/:id"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/prayers"]}>
                <PrayerDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/testimonyList"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/testimonies"]}>
                <TestimonyManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/testimonyDetails/:id"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/testimonies"]}>
                <TestimonyDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="/contentManagement/audio"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/contentManagement/audio"]}>
                <AudioManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contentManagement/bibleVersion"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/contentManagement/bibleVersion"]}>
                <BibleVersionManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contentManagement/devotion"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/contentManagement/devotion"]}>
                <DevotionManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contentManagement/document"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/contentManagement/document"]}>
                <DocumentManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contentManagement/podcast"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/contentManagement/podcast"]}>
                <PodcastManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contentManagement/quote"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/contentManagement/quote"]}>
                <QuoteManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contentManagement/streaming"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/contentManagement/streaming"]}>
                <StreamingManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contentManagement/verses"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/contentManagement/verses"]}>
                <VerseManagement />
              </ProtectedRoute>
            }
          />

          <Route
            path="/volunteering/formList"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/volunteering"]}>
                <FormList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/volunteering/createForm"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/volunteering"]}>
                <CreateForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/volunteering/editForm/:formId"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/volunteering"]}>
                <EditForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/volunteering/formSubmissions/:formId"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/volunteering"]}>
                <FormsSubmissions />
              </ProtectedRoute>
            }
          />

          <Route
            path="/donationList"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/donations"]}>
                <DonationList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reportList"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/reports"]}>
                <ReportsAndAnalytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute allowedRoles={ROUTE_ACCESS["/settings"]}>
                <SettingsAndPreferences />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
